import {useMemo} from 'react';

import {cloneArr, toOwnerIds, initialOwners} from './projectSettingsHelpers';

const tagsEqual = (a, b) => JSON.stringify(cloneArr(a).sort()) === JSON.stringify(cloneArr(b).sort());

const ownersEqual = (a, b) => JSON.stringify(toOwnerIds(a).sort()) === JSON.stringify(toOwnerIds(b).sort());

const isFieldDirty = (snapshot, edited, originalPrivacyLevel) => (
    edited.name !== (snapshot.ProjectName || '')
    || edited.description !== (snapshot.ProjectDescription || '')
    || !tagsEqual(edited.tags, snapshot.Tags)
    || edited.coverImage !== (snapshot.ProjectCoverImage || '')
    || edited.coverImageThumb !== (snapshot.ProjectCoverImageThumb || '')
    || edited.default3DModel !== (snapshot.Default3DModel || null)
    || edited.isRolesPermittedByDefault !== !!snapshot.IsRolesPermittedByDefault
    || !ownersEqual(edited.projectOwners, initialOwners(snapshot))
    || edited.privacyLevel !== originalPrivacyLevel
);

const useProjectDirtyCheck = (originalSnapshot, originalPrivacyLevel, edited) => useMemo(() => {
    if (!originalSnapshot) return false;
    return isFieldDirty(originalSnapshot, edited, originalPrivacyLevel);
}, [originalSnapshot, originalPrivacyLevel, edited.name, edited.description, edited.tags, edited.coverImage, edited.coverImageThumb, edited.default3DModel, edited.isRolesPermittedByDefault, edited.projectOwners, edited.privacyLevel]);

export default useProjectDirtyCheck;
